import { ApiRoutes } from "../../app/routers/ApiRoutes";
import { Observable } from "rxjs";
import { IBaseResponse } from "../../app/models/App/IBaseResponse";
import { INotifications } from "../../app/models/Notifications/inotifications";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
  HttpTransportType,
} from "@microsoft/signalr";
import { ToastService } from "../toast.service";
import { INotify } from "src/app/shared/app/models/Notifications/inotifications";
@Injectable({
  providedIn: "root",
})
export class NotificationsService {
  private readonly env = environment.baseURL;
  private hubConnectionBuilder!: HubConnection;
  private connectionId!: string;
  constructor(
    private http: HttpClient,
    private toastService: ToastService,
  ) {}

  getAlerts(): Observable<IBaseResponse<INotifications[]>> {
    return this.http.get<IBaseResponse<INotifications[]>>(
      this.env + ApiRoutes.Alerts.alerts,
    );
  }

  openConnection(userId: string) {
    this.hubConnectionBuilder = new HubConnectionBuilder()
      .withUrl(this.env + "/Notify", {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .configureLogging(LogLevel.None)
      .withAutomaticReconnect()
      .build();
    this.hubConnectionBuilder
      .start()
      .then(() => this._getConntectionId(userId))
      .catch((ث) => console.error(ث));
    this.hubConnectionBuilder.on("SendNotification", (result: INotify) => {
      this.toastService.show(
        result.notificationName!,
        result.message!,
        new Date(result.dateTime!).toISOString(),
        {
          classname: "text-light",
          icon: "ri-notification-4-line",
          autoHide: false,
        },
      );
    });
  }

  private _getConntectionId(userId: string) {
    this.hubConnectionBuilder.on("ReceiveConnectionId", (data) => {
      this.connectionId = data;
      this.hubConnectionBuilder.invoke("AddClient", userId, this.connectionId);
    });
  }
}
